//Creates new Thermocycler and assigns ID and type
export const createThermocycler = (data) => {
    //data = {id, type}
    return { type: "CREATE_THERMOCYCLER", payload: data}
}
//Change tip attached status
export const thermocyclerOpen = (data) => {
    //data = {id, open}
    return { type: "THERMOCYCLER_OPEN", payload: data}
}
//Change tip attached status
export const setThermocyclerControlVisibility = (data) => {
    //data = {id, open}
    return { type: "SET_THERMOCYCLER_CONTROLS_VISIBLE", payload: data}
}
export const addTubeToThermocycler = (data) => {
    //data = {cathodeConnected}
    return { type: "ADD_TUBE_TO_THERMOCYCLER", payload: data}
}
export const removeTubeFromThermocycler = (data) => {
    //data = {cathodeConnected}
    return { type: "REMOVE_TUBE_FROM_THERMOCYCLER", payload: data}
}
export const removeAllTubesFromThermocycler = (data) => {
    //data = {cathodeConnected}
    return { type: "REMOVE_ALL_TUBES_FROM_THERMOCYCLER", payload: data}
}


export const setThermocyclerVolume = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_VOLUME", payload: data}
}
export const setThermocyclerLid = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_LID", payload: data}
}

export const setThermocyclerDurations = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_DURATIONS", payload: data}
}
export const setThermocyclerRunning = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_RUNNING", payload: data}
}
export const setThermocyclerCurrentTime = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_CURRENT_TIME", payload: data}
}
export const setThermocyclerTotalTime = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_TOTAL_TIME", payload: data}
}
export const setThermocyclerTotalElapsedTime = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_ELAPSED_TIME", payload: data}
}
export const setThermocyclerSaved = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_SAVED", payload: data}
}
export const setThermocyclerInnerSection = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_INNER_SECTION", payload: data}
}
export const setThermocyclerEditConnection = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_EDIT_CONNECTION", payload: data}
}
export const setThermocyclerSection = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_SECTION", payload: data}
}
export const setThermocyclerDialog = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_DIALOG", payload: data}
}
export const setThermocyclerDialogDisplay = (data) => {
    //data = {cathodeConnected}
    return { type: "SET_THERMOCYCLER_DIALOG_DISPLAY", payload: data}
}
export const updateThermocyclerSequence = (data) => {
    //data = {cathodeConnected}
    return { type: "UPDATE_THERMOCYCLER_SEQUENCE", payload: data}
}
export const updateThermocyclerTempSequence = (data) => {
    //data = {cathodeConnected}
    return { type: "UPDATE_THERMOCYCLER_TEMP_SEQUENCE", payload: data}
}

export const updateThermocyclerSequenceTemp = (data) => {
    //data = {cathodeConnected}
    return { type: "UPDATE_THERMOCYCLER_SEQUENCE_TEMP", payload: data}
}
export const updateThermocyclerSequenceTime = (data) => {
    //data = {cathodeConnected}
    return { type: "UPDATE_THERMOCYCLER_SEQUENCE_TIME", payload: data}
}
export const updateThermocyclerSequenceRepeat = (data) => {
    //data = {cathodeConnected}
    return { type: "UPDATE_THERMOCYCLER_SEQUENCE_REPEAT", payload: data}
}


export const addThermocyclerSequence = (data) => {
    //data = {cathodeConnected}
    return { type: "ADD_THERMOCYCLER_SEQUENCE", payload: data}
}
export const removeThermocyclerSequence = (data) => {
    //data = {cathodeConnected}
    return { type: "REMOVE_THERMOCYCLER_SEQUENCE", payload: data}
}
export const eraseThermocyclerSequence = (data) => {
    //data = {cathodeConnected}
    return { type: "ERASE_THERMOCYCLER_SEQUENCE", payload: data}
}
